import { QueryColumn } from 'core-app/features/work-packages/components/wp-query/query-column';

export const internalSortColumn = {
  id: '__internal-sorthandle',
} as QueryColumn;

export const internalContextMenuColumn = {
  id: '__internal-contextMenu',
} as QueryColumn;

export const internalBaselineColumn = {
  id: '__internal-baseline',
} as QueryColumn;

export const sharedUserColumn = {
 id: 'sharedWithUsers',
} as QueryColumn;
